import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor() {}
  listSocial: any = [
    'https://fpt.vn/storage/upload/images/menus/social-network/foot-hifpt.png',
    'https://fpt.vn/storage/upload/images/menus/social-network/foot-youtube.png',
    'https://fpt.vn/storage/upload/images/menus/social-network/foot-instagram.png',
    'https://fpt.vn/storage/upload/images/menus/social-network/foot-zalo.png',
    'https://fpt.vn/storage/upload/images/menus/social-network/foot-facebook.png',
  ];
  listProduct: any = [
    'https://fpt.vn/storage/upload/images/banners/logos/internet.png',
    'https://fpt.vn/storage/upload/images/banners/logos/logo-fpt-smarthome.png',
    'https://fpt.vn/storage/upload/images/banners/logos/fpt-play.png',
    'https://fpt.vn/storage/upload/images/banners/logos/camera.png',
    'https://fpt.vn/storage/upload/images/banners/logos/foxpay-logo.png',
    'https://fpt.vn/storage/upload/images/banners/logos/fpt-play-box.png',
    'https://fpt.vn/storage/upload/images/banners/logos/fshare.png',
    'https://fpt.vn/storage/upload/images/banners/logos/fsend.png',
    'https://fpt.vn/storage/upload/images/banners/logos/ihome.png',
  ];
  slideConfig = {
    speed: 300,
    slidesToShow: 7,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    cssEase: 'linear',
    fade: false,
    autoplay: false,
    dots: false,
    draggable: true,
    arrows: true,
    centerMode: false,
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-right-slick.png"/></button>',
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-left-slick.png"/></button>',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
  footerMenu1: any = [
    {
      name: 'Giới thiệu chung',
      url: 'https://fpt.vn/vi/ve-fpt-telecom/gioi-thieu-chung.html',
    },
    {
      name: 'Liên kết - Thành viên',
      url: 'https://fpt.vn/vi/ve-fpt-telecom/lien-ket-thanh-vien.htmlhttps://fpt.vn/vi/ve-fpt-telecom/lien-ket-thanh-vien.html',
    },
    {
      name: 'Khách hàng - Đối tác',
      url: 'https://fpt.vn/vi/ve-fpt-telecom/khach-hang-doi-tac',
    },
    {
      name: 'Quan hệ cổ đông',
      url: 'https://fpt.vn/vi/ve-fpt-telecom/quan-he-co-dong',
    },
    {
      name: 'Tập đoàn FPT',
      url: 'https://fpt.vn/vi/ve-fpt-telecom/tap-doan-fpt.html',
    },
  ];
  footerMenu2: any = [
    {
      name: 'Hướng dẫn sử dụng dịch vụ',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/ho-tro/ho-tro-thong-tin/huong-dan-su-dung',
    },
    {
      name: 'Giới thiệu bạn bè',
      url: 'https://gioithieubanbe.fpt.vn/',
    },
    {
      name: 'Thanh toán Online',
      url: 'https://fpt.vn/pay',
    },
    {
      name: 'Góp ý khách hàng',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/ho-tro/phan-hoi-khach-hang/gop-y.html',
    },
    {
      name: 'Lịch phát sóng',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/san-pham-dich-vu/truyen-hinh-fpt/lich-phat-song.html',
    },
  ];
  footerMenu3: any = [
    {
      name: 'Đăng ký Online',
      url: 'https://shop.fpt.vn/',
    },
    {
      name: 'Sản phẩm dịch vụ',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/san-pham-dich-vu/internet-fpt/cap-quang-ca-nhan.html',
    },
    {
      name: 'Khuyến mại',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/khuyen-mai',
    },
    {
      name: 'Tìm điểm giao dịch',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/ho-tro/lien-he-24-7/diem-giao-dich',
    },
    {
      name: 'Tin tức',
      url: 'https://fpt.vn/vi/khach-hang-ca-nhan/tin-tuc',
    },
  ];
  showMenu1 = false;
  showMenu2 = false;
  showMenu3 = false;
}
